
import { useState, useEffect } from 'react'
import { Outlet } from "react-router-dom";
import { HeaderLayout } from '../../PageLayout'
import { ResponsiveSiteNav, ToggleMenuBtn } from '../../SiteNavigation';
import { DefaultPageFooter, LogoBanner } from '../../Template' 
import '../../pagelayout.css'
import '../../pagelayout_desktop.css'

export default function Root() {

    const [sideNavHidden, setSideNavHidden] = useState(false);
    const [sideNavLayout, setSideNavLayout] = useState('hide-sidenav');

    function handleNavToggleClick() {
        console.log('handleNavToggleClick entered')
        setSideNavHidden(!sideNavHidden);
    }

    function handleNavInput() {
        setSideNavHidden(!sideNavHidden);
    }

    useEffect(() => {
        setSideNavLayout(!sideNavHidden ? "hide-sidenav" : "show-sidenav")
    }, [sideNavHidden]);

    return (
        <div id="page-layout-container">
            <HeaderLayout>
                <LogoBanner/>
                <ToggleMenuBtn handleClick={handleNavToggleClick} />
                <ResponsiveSiteNav
                    handleNavInput={handleNavInput}
                    navLayout={sideNavLayout} />
            </HeaderLayout>
            <main id="page-layout-main">
                <Outlet />
            </main>
            <DefaultPageFooter />
        </div>
    );
}